

export const getWebViewStyling = (isWebView) => {
    return {
        contentContainer: {
            marginTop: !isWebView ? '76px' : '0px'
        }
    }
}